import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can wire up logging here if needed
    // eslint-disable-next-line no-console
    console.error("App crashed:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
          <div className="max-w-xl rounded-2xl border bg-white p-6 shadow-sm">
            <div className="mb-2 text-lg font-semibold">Something went wrong</div>
            <div className="text-xs text-rose-700 break-words whitespace-pre-wrap">
              {String(this.state.error?.message || this.state.error || "Unknown error")}
            </div>
            <button
              className="mt-4 rounded-lg px-4 py-2 text-sm font-medium bg-dark-card border border-dark-border text-dark-text-muted hover:bg-dark-border hover:text-dark-text"
              onClick={() => window.location.reload()}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
